import React, { useEffect, useState } from 'react';
import { useAuthenticated, useQuery, Loading, Error } from 'react-admin';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import dataProvider from '../dataProvider';
import { useDataProvider } from 'react-admin';

const useStyles = makeStyles({
  container: {
    paddingTop: '1rem',
  },
  Text: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: '0.13px',
    color: '#4f5064',
  },
  Title: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: ' 0.13px',
    color: '#ffffff',
  }
});

const ServerStatus = () => {
  useAuthenticated();

  const classes = useStyles();
  const dataProvider = useDataProvider()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()

  useEffect(() => {
    setLoading(true)
    dataProvider('GET_LIST', "ServerInfo/status", {
      filter: {
        where: {}
      },
      pagination: {},
      sort: {}

    })
      .then(({ data }) => {
        setData(data)
        setLoading(false);
      })
      .catch(error => {
  
        setLoading(false);
      })
  }, [])

  if (loading) return <Loading />;
  if (!data) return null;

  return (
    <Box style={{ padding: '48px 74px' }}>
      <TableContainer className={classes.container} component={Paper} style={{ padding: '36px', width: '95%' }}>
        <Table size="small">
          <TableBody>
            {
              data.map(infoItem => {
                return (<TableRow className={classes.Title} key={infoItem.name}>
                  <TableCell className={classes.Text}>{infoItem.name}</TableCell>
                  <TableCell className={classes.Text}>{infoItem.value}</TableCell>
                </TableRow>);
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ServerStatus;